<template>
  <div class="home">
    <input type="text" v-model="text">
    
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'


export default {
  data() {
    return {
      text: 'this is some text' 
    }
  },
  name: 'home',
  // components: {
  //   HelloWorld
  // }
}
</script>
